export default __webpack_public_path__ + "static/media/dis-01@2x.dbc00f8c.jpg";